import { OverviewIcon } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import { BuildingSectionProps, overviewFieldValues } from "../BuildingConstruction.constants";
import BuildingSectionBody from "./BuildingSectionBody";

function BuildingOverview(props: BuildingSectionProps) {
    return (
        <>
            {props.isEditing && (
                <div className="construction-sidebar__body__header" style={{ paddingTop: "var(--size-margin-m)" }}>
                    <OverviewIcon />
                    <Header size="medium">Overview</Header>
                </div>
            )}
            <BuildingSectionBody {...props} fields={overviewFieldValues} />
        </>
    );
}

export default BuildingOverview;
